import { useMemo } from 'react';

/**
 * Translation dictionary structure
 * Injected by server via window.__i18n
 */
interface TranslationDict {
  [key: string]: string;
}

/**
 * Global window interface extension
 */
declare global {
  interface Window {
    __i18n?: TranslationDict;
  }
}

/**
 * Custom hook for accessing i18n translations
 * Reads from window.__i18n injected by EJS server-side
 *
 * Usage:
 * ```tsx
 * const t = useTranslations();
 * return <label>{t('filter.organization')}</label>
 * ```
 */
export function useTranslations() {
  const translations = useMemo(() => {
    // Access translations from window (injected by EJS)
    return window.__i18n || {};
  }, []);

  /**
   * Translate a key to localized string
   * Falls back to key if translation not found
   */
  const t = (key: string): string => {
    return translations[key] || key;
  };

  return t;
}
